import{gql as e}from"@apollo/client";e`
  mutation DeleteFiles($ids: [ID!]!) {
    deleteFiles(filter: { id: { valueIn: $ids } })
  }
`,e`
  mutation UpdateFile($id: ID!, $updateFileDto: FileUpdateDto!) {
    updateFile(id: $id, updateFileDto: $updateFileDto) {
      id
      name
    }
  }
`,e`
  mutation MakeFilePublic($id: ID!) {
    makeFilePublic(id: $id) {
      id
      url
      isPublic
    }
  }
`,e`
  mutation MakeFilePrivate($id: ID!) {
    makeFilePrivate(id: $id) {
      id
      url
      isPublic
    }
  }
`;const i=e`
    mutation CreateFileUpload($createFileDto: FileCreateDto!){
        createFileUpload(createFileDto: $createFileDto){
            id
            name
            formFields
            uploadUrl
            contentType
        }
    }
`,t=e`
  mutation UpdateFileStatus($id: ID!, $status: FileStatusEnum!) {
    updateFileStatus(id: $id, status: $status) {
      id
      name
      url
      createdAt
    }
  }
`;export{i as createFileUploadMutation,t as updateFileStatusMutation};